import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import packageJson from '../../package.json';

const BASE_URL = packageJson.apiUrl;

const BlogDetail = () => {
    const { id } = useParams(); // Get blog ID from the URL
    const [blog, setBlog] = useState(null); // State to store blog details
    const [loading, setLoading] = useState(true); // State to track loading status
    const [error, setError] = useState(""); // State to track errors

    useEffect(() => {
        // Fetch blog details using the blog ID
        axios
            .get(`${BASE_URL}/blog/${id}`)
            .then((response) => {
                if (response.data.success) {
                    setBlog(response.data.data); // Set blog details
                } else {
                    setError("Blog not found.");
                }
                setLoading(false); // Set loading to false
            })
            .catch((error) => {
                console.error("There was an error fetching the blog details!", error);
                setError("Error fetching blog details. Please try again later.");
                setLoading(false); // Set loading to false
            });
    }, [id]);

    if (loading) {
        return <p>Loading...</p>; // Show loading message
    }

    if (error) {
        return <p>{error}</p>; // Show error message if there's an error
    }

    if (!blog) {
        return <p>No blog details available.</p>; // Fallback message if no blog data
    }

    return (
        <>
            <BreadCrumb currentPage={blog.name} />
            <section className="section-space detail-sec">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <p className="blog-tag">
                                <i className="bi bi-folder2-open"></i> {blog.authorname}
                            </p>
                            <h3 className="det-title">{blog.name}</h3>
							<p><img src={blog.image} className='img-fluid mt-3 mb-3 rounded w-100' alt="" /></p>
                            <p
                                className="blog-des"
                                dangerouslySetInnerHTML={{ __html: blog.description }}
                            ></p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default BlogDetail;
